import {
  Box,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import deletebox from "../../Utils/Images/deletebox.png";
import editbox from "../../Utils/Images/editbox.png";
import eyebox from "../../Utils/Images/eyebox.png";
import { handleDeleteChallenges } from "../../APIs/Function/Workout/Challenges/DeleteChallenges";
import { Link } from "react-router-dom";
import DeleteModal from "../Modal/DeleteModal";
import { GetChallenges } from "../../APIs/Function/Workout/Challenges/GetChallenges";
import Loader from "../Loader/Loader";
const WeeklyChallangeTable = ({
  loadinga,
  setData,
  data,
  Column1,
  Column2,
  Column3,
  Column4,
  Column5,
  Column6,
}) => {
  const [modalID, setModalID] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setOpen(false);
      await handleDeleteChallenges(modalID);
      alert("Challenge Delete Successfully");
      setLoading(true);
      let res = await GetChallenges();
      setLoading(false);
      setData(res.r);
    } catch (error) {
      console.error("Error Deleting challenge:", error);
    }
  };

  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {loading || loadinga ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              boxShadow: "none",
              outline: "none",
              mb: "10px",
              border: "none",
              mt: "30px",
              boxSizing: "border-box",
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "8 5%",
                      color: "#252525",
                    }}
                  >
                    {Column1}
                  </Typography>
                </Paper>
              </Grid>

              {/* Second Column */}

              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "8 5%",
                      color: "#252525",
                    }}
                  >
                    {Column2}
                  </Typography>
                </Paper>
              </Grid>

              {/* Third Column */}

              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "8 5%",
                      color: "#252525",
                    }}
                  >
                    {Column3}
                  </Typography>
                </Paper>
              </Grid>

              {/* Fourth Column */}

              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "8 5%",
                      color: "#252525",
                    }}
                  >
                    {Column4}
                  </Typography>
                </Paper>
              </Grid>
              {/* Fifth Column */}
              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "8 5%",
                      color: "#252525",
                    }}
                  >
                    {Column5}
                  </Typography>
                </Paper>
              </Grid>
              {/* Sixth Column */}
              <Grid item xs={1.5} md={1.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "8 5%",
                      color: "#252525",
                    }}
                  >
                    {Column6}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          {/* table data */}
          <Box
            sx={{
              border: "0.5px solid #DDDDDD",
              overflow: "auto",
              minHeight: "100px",
              maxHeight: "415px",
              "&:hover": {
                "::-webkit-scrollbar": {
                  width: "5px",
                  borderRadius: "10px",
                },
                "::-webkit-scrollbar-thumb": {
                  bgcolor: "gray",
                  borderRadius: "10px",
                },
              },
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                {data?.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      {i + 1}
                    </Typography>
                  </Paper>
                ))}
              </Grid>

              {/* Second Column */}

              <Grid item xs={2.5} md={2.5}>
                {data.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "100%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {e.title}
                    </Typography>
                  </Paper>
                ))}
              </Grid>

              {/* Third Column */}

              <Grid item xs={2.5} md={2.5}>
                {data.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "100%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {e.c_type}
                    </Typography>
                  </Paper>
                ))}
              </Grid>
              {/* Fourth Column */}
              <Grid item xs={2.5} md={2.5}>
                {data.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "100%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {e.parameter}
                    </Typography>
                  </Paper>
                ))}
              </Grid>
              {/* Fifth Column */}
              <Grid item xs={2.5} md={2.5}>
                {data.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      display: "flex",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip key={i} title={e.description} arrow>
                      <Typography
                        noWrap
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                          maxHeight: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          p: "0 20px",
                        }}
                      >
                        {e.description}
                      </Typography>
                    </Tooltip>
                  </Paper>
                ))}
              </Grid>
              {/* Sixth Column */}
              <Grid item xs={1.5} md={1.5}>
                {data.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        boxSizing: "border-box",
                        p: 1,
                        alignItems: "center",
                        display: "flex",
                        width: "100%",
                        gap: 1,
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <Link to={`/singlechallenge/${e.id}`}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={eyebox}
                            alt="logo"
                          />
                        </Link>
                      </Box>

                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <Link to={`/editchallenge/${e.id}`}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={editbox}
                            alt="logo"
                          />
                        </Link>
                      </Box>

                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <img
                          width={"100%"}
                          height={"100%"}
                          src={deletebox}
                          alt=""
                          onClick={() => handleModal(e.id)}
                        />
                      </Box>
                    </Box>
                  </Paper>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
      <DeleteModal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={handleClose}
      />
    </>
  );
};

export default WeeklyChallangeTable;
